import axios from 'axios';

interface ConstituenciesData {
    id: string | number | null;
    all: [];
    allGrouped: [];
    selected: null | object;
}

interface EmailData {
    subject: string;
    body: string;
    hasContent: boolean;
}

interface PetitionData {
    id: string | number;
    name: string;
    slug: string;
}

interface PetitionSignatureData {
    id: string | number;
    mpEmailWithName: string;
}

interface GecData {
    constituenciesData: ConstituenciesData;
    email: EmailData;
    petition: PetitionData;
    petitionSignature: PetitionSignatureData;
}

export function setupGenerateEmailContent(params: GecData) {
    return {
        counts: {
            subject: 0,
            body: 0
        },
        constituencyId: params.constituenciesData.id,
        constituencies: params.constituenciesData.all,
        constituenciesGrouped: params.constituenciesData.allGrouped,
        constituency: params.constituenciesData.selected,
        emailSubject: params.email.subject,
        emailBody: params.email.body,
        hasContent: params.email.hasContent,
        mailto: "",
        mpEmailWithName: params.petitionSignature.mpEmailWithName,
        get hasConstituency() {
            return this.constituency !== null;
        },
        generateEmailContent() {
            axios.put(`/petitions/${params.petition.slug}/write-mp-content`, {
                params: {
                    id: params.petitionSignature.id,
                }
            })
                .then(response => {
                    this.emailSubject = response.data.subject;
                    this.emailBody = response.data.body;
                    this.counts.subject = this.emailSubject.length;
                    this.counts.body = this.emailBody.length;
                    this.hasContent = true;
                })
                .catch(response => {
                    console.error(response.data);
                })
                .finally(() => {
                    this.hasContent = true;
                });
        },
        recordEmailIntent(e: Event) {
            if (this.constituency === null) {
                e.preventDefault();
                return;
            }
            axios.patch(`/petitions/${params.petition.slug}/write-mp-content`, {
                petitionSignatureId: params.petitionSignature.id,
                constituencyId: this.constituency.id,
                emailBody: this.emailBody,
                emailSubject: this.emailSubject,
                '_sent': true,
            });
        },
        replaceFirstLine(input: string, newFirstLine: string) {
            return input.replace(/^.*$/m, newFirstLine);
        },
        generateMailtoLink() {
            this.mailto = `mailto:${encodeURIComponent(this.constituency?.mp?.emailWithName)}?subject=${encodeURIComponent(this.emailSubject)}&body=${encodeURIComponent(this.emailBody)}`;
        },
        init() {
            this.$watch('emailSubject', () => {
                this.generateMailtoLink();
            });
            this.$watch('emailBody', () => {
                this.generateMailtoLink();
            });
            this.$watch('constituencyId', () => {
                var id = parseInt(this.constituencyId);
                this.constituency = this.constituencies.find(constituency => constituency.id === id);
                this.emailBody = this.replaceFirstLine(this.emailBody, `Dear ${this.constituency.mp.name},`);
                axios.patch(`/petitions/${params.petition.slug}/write-mp-content`, {
                    petitionSignatureId: params.petitionSignature.id,
                    constituencyId: this.constituency.id,
                    emailBody: this.emailBody,
                    emailSubject: this.emailSubject,
                    '_sent': false,
                });
            });
            this.counts.subject = this.emailSubject.length;
            this.counts.body = this.emailBody.length;
            if (!this.hasContent) {
                this.generateEmailContent();
            } else {
                this.generateMailtoLink();
            }
        },
    };
}
